.welcome {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--tuna-spacing-3);
  padding: var(--tuna-spacing-5);
  text-align: center;
}

.intro {
  margin: 0;
  max-width: 460px;
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-muted);
}

.cardGrid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--tuna-spacing-3);
  width: 100%;
  max-width: 780px;
  margin-top: var(--tuna-spacing-2);
}

.card {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: var(--tuna-spacing-1);
  padding: var(--tuna-spacing-3);
  text-align: left;
  background: var(--tuna-palette-background-paper);
  border: 2px solid var(--tuna-palette-divider);
  border-radius: var(--tuna-shape-radius-md);
  cursor: pointer;
  transition:
    background 120ms ease,
    border-color 120ms ease;
}

.card:hover {
  border-color: var(--tuna-palette-primary-main);
  background: var(--tuna-palette-action-hover);
}

.card[aria-pressed='true'] {
  border-color: var(--tuna-palette-primary-main);
  background: var(--tuna-palette-action-selected, var(--tuna-palette-action-hover));
}

.cardTitle {
  margin: 0;
  font-size: var(--tuna-typography-fontSize-lg);
  font-weight: 700;
}

.cardBody {
  margin: 0;
  font-size: var(--tuna-typography-body2-fontSize);
}

.cardMeta {
  margin: 0;
  font-size: var(--tuna-typography-caption-fontSize);
  color: var(--tuna-content-muted);
}

@media (max-width: 899.95px) {
  .cardGrid {
    grid-template-columns: 1fr;
  }
}
